<template>
  <div class="animated fadeIn">
    <b-alert :variant="dismissibleType"
             dismissible
             :show="showDismissibleAlert"
             @dismissed="showDismissibleAlert=false">
      {{ errMsg }}
    </b-alert>
    <div class="mt-4">

      <b-row>
        <b-col>
          <b-card>
            <template v-slot:header>
              <strong>Queued Reports</strong>
              <button id="btnRefresh" class="btn btn-primary pull-right" @click="refreshHistory">
                <strong class="text-white">Refresh</strong>
              </button>
            </template>
            <template>
              <b-row>
                <b-col class="col-6 pb-2">
                  <b-input-group>
                    <b-form-input id="inpSearch" v-model="filter" placeholder="Type to Search" />
                    <b-input-group-append>
                      <b-btn id="btnClear" :disabled="!filter" @click="filter = ''">Clear</b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </b-col>
              </b-row>
            </template>
            <b-table :items="runningReports" :fields="runningReportFields" hover striped bordered small :current-page="currentPage" :per-page="perPage"
                     show-empty :filter="filter" @filtered="onFiltered">

              <template v-slot:cell(perc_done)="data">
                <div class="progress" style="background-color: #a8dcff;">
                  <div class="progress-bar progress-bar-striped progress-bar-animated"
                       v-bind:style="{ width: data.value + '%' }">{{data.value}}%</div>
                </div>
              </template>
              <template v-slot:cell(msg)="data">
                <div style="min-width:50px">{{data.value}}&nbsp;</div>
              </template>
              <template v-slot:cell(cancel)="data">
                <div style="min-width:50px"><a href="#" class="btn btn-danger btn-sm" @click="CancelReport(data)">Cancel</a></div>
              </template>
            </b-table>
             
            <nav>
              <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" />
              {{currentPage}} of {{totalRows}}
            </nav> 
            
        </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-card>
            <template v-slot:header>
              <strong>Report History</strong>
              <button id="btnRetry" class="btn btn-primary pull-right" @click="retryGroup">
                <strong class="text-white">Retry</strong>
              </button>
            </template>

            <b-row>
              <div class="headerCategory mr-1 bordered" style="display:flex;flex:2; ">
                <div class="category_title m-0">
                  <b-form-input type="text" placeholder="New Category" v-model="NewCategory" class="form-control" size="sm" />
                </div>
                <div class="" @click="AddCustomCategory()">
                  <button><i class="fa fa-plus ml-1 mr-1 pt-1 " size="sm"></i></button>
                </div>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:3;">
                <div class="category_title m-0 ml-5">
                  <b-form-input type="text" v-model="searchValue" placeholder="Search" class="form-control" size="sm" />
                  <button @click="searchReport()"><i class="fa fa-search ml-1 mr-1 pt-1"></i>  </button>
                </div>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:2;">
                <b-form-select v-model="SelectedFolder" :options="Folders" @change="ChangedFolder()" size="sm" class="form-control">
                </b-form-select>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:2;justify-content:start;">
                <label style="margin-left:10px;margin-top:7px;">Filtered [{{this.filteredReports.length}}]</label>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:2;">                 
                  Group               
                <b-form-select v-model="groupid" :options="groupids" @change="ChangedFolder()" size="sm" class="form-control">
                </b-form-select>
              </div>
              <div class="headerCategory m-0" style="display:flex;flex:3;">
                <div class="ml-3 mr-1">
                  Move To
                </div>
                <div class="category_title m-0">
                  <b-form-select v-model="MoveCategory" :options="TransferCategories" size="sm" class="form-control"
                                 value-field="CategoryId"
                                 text-field="CategoryName">
                  </b-form-select>
                  <b-button variant="success" @click="moveSelectionToCategory()" size="sm"><i class="fa fa-exchange ml-2 mr-2 pt-1"></i></b-button>

                </div>
                <div class="ml-2 mr-2">
                  Select All
                </div>
                <div class="m-0 mr-2 text-right">
                  <input type="checkbox" @change="selectAll" v-model="IsAllSelection" style="display:flex;align-self:center;margin-right:10px;" class="" />
                </div>
              </div>

            </b-row>

            <b-row>

              <div class="categories mr-1 bordered">
                <div >
                  <drop class="customCategory" v-for="category in ReportHistoryCategories"
                        v-bind:class="{ 'category_selected':boolLoading==false && IsCategorySelected(category.CategoryId) }" ref="category"
                        @drop="function(transferData, nativeEvent) { handleDropCustom(category, transferData, nativeEvent) }">
                    <div class="category_title" @click="SetActiveCategory(category)">
                      {{category.CategoryName}} <!--({{category.ReportCount}})-->
                    </div>
                    <div class="category_action">
                      <a href="#" @click="archiveCategory(category)"  v-show="category.CategoryId!== ARCHIVES "><i class="fa fa-trash ml-2"></i></a>
                    </div>
                  </drop>
                </div>
              </div>

              <b-col class="col-lg-12 reports">
                <div class="report_row_slim_header">
                  <div class="report_id">History ID</div>
                  <!--<div class="report_id">Report ID</div>-->
                  <div class="report_template_name"><span>Title</span></div>
                  <div v-show="SelectedFolder.value !== 1" class="report_category">Category</div>
                  <div class="report_user">User</div>
                  <div class="report_date">Report Date</div>
                  <div class="report_xls">Outputs</div> 
                  <div class="report_action">Actions</div>
                </div>

                <drag class="report_row" v-for="(report,index) in filteredReports" :transfer-data="report" v-bind:class="{report_row_hover : report.IsSelected===true}">
                  <div class="report_id">{{report.history_id}}</div>
                  <!--<div class="report_id">{{report.report_id}}</div>-->
                  <div class="report_template_name"><span>{{report.title}}</span></div>
                  <div v-show="SelectedFolder.value !==1" class="report_category" >{{report.category_name}}</div> 
                  <div class="report_user">{{report.createdby}}</div>
                  <div class="report_date">{{report.created | formatDate}}</div>
                  <div class="report_xls">
                    <label v-if="report.billable === false">CANCELLED</label>
                    <a v-if="report.excel && report.billable" href="#" @click="DownloadReport(report.excel)">XLS</a>
                    <a v-if="report.json && report.billable" href="#" @click="DownloadReport(report.json)">JSON</a>
                    <slot v-if="report.noreport">
                      <label>Done</label>
                    </slot>
                  </div>
                  <div class="report_action" style="display:flex;flex-flow:row">
                    <a href="#" style="display:flex"
                       v-if="SelectedCategory.CategoryId!==ARCHIVES && !isKioskMode"
                       @click="moveOneReportToCategory(report,ARCHIVES)"><i class="fa fa-trash ml-2"></i></a>
                    <a href="#" class="ml-3"
                       v-if="SelectedCategory.CategoryId !== FAVORITES "
                       style="display:flex" @click="moveOneReportToCategory(report,FAVORITES)">
                      <i class="fa fa-star ml-2"></i>
                    </a>
                    <input type="checkbox" v-model="report.IsSelected" value="true" unchecked-value="false" style="display:flex;align-self:center;" class="ml-3" />
                  </div>
                </drag>
                </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </div>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>
<script>

import Vue from 'vue'
import axios from 'axios'
import Store from '@/store'
import loading from 'vue-full-loading'
import Vue2Filters from 'vue2-filters'
import { setTimeout } from 'timers'
import moment from 'moment'
//import { cat } from 'shelljs'
import { Drag, Drop } from 'vue-drag-drop'
import { confirm, alert } from 'devextreme/ui/dialog'

Vue.use(Vue2Filters)
export default {
  components: {
    loading,
    'drag': Drag,
    'drop': Drop
  },
  created () {
    var self = this
    self.Init()
  },
  data () {
    return {
      templatetypeid: 2,
      errMsg: '',
      isDragging: false,
      isKioskMode: false,
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      initLoad: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      isInternalStaff: Store.state.isInternalStaff || Store.state.isRustyAccount,
      filterUnrec: false,
      filterCertified: false,
      tbxFilter: '',
      processedReports: [],
      unassignedReports: [],
      data: {},
      filteredReports: [],
      SelectedReports: [],
      NewCategory: '',
      searchValue: '',
      runningReports: [],
      SelectedCategory: {},
      TransferCategories: [],
      MoveCategory: {},
      IsAllSelection: false,
      Folders: [],
      SelectedFolder: {},
      FAVORITES: 5,
      UNASSIGNED: 4,
      ARCHIVES: 6,
      AllFolders: [],
      divs: [],
      reportsHistory: [],
      ReportHistoryCategories: [],
      rhcurrentPage: 1,
      rhperPage: 10,
      rhtotalRows: 0,
      processedReportFields: [
        { key: 'created', label: 'Created', sortable: true },
        { key: 'createdby', label: 'Created By', sortable: true },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'excel', label: 'Excel', sortable: false },
        { key: 'html', label: 'HTML', sortable: false },
        { key: 'json', label: 'JSON', sortable: false },
        { key: 'category_id', label: '', sortable: false, visible: false },
        { key: 'category_name', label: 'Category', sortable: false },
        { key: 'blank', label: '', sortable: false }
      ],
      runningReportFields: [
        { key: 'started', label: 'Started', sortable: true },
        { key: 'title', label: 'Title', sortable: true },
        { key: 'status', label: 'Status', sortable: false },
        { key: 'perc_done', label: 'Progress', sortable: false },
        { key: 'msg', label: '', sortable: false },
        { key: 'cancel', label: '', sortable: false }
      ],
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      externalReport: false,
      categories: [],
      groupids: [],
      groupid: 0,
      filter: null
    }
  },
  watch: {
    runningReports: {
      handler: function (val, oldVal) {
        if (val.length !== oldVal.length) {

        }
      },
      deep: true
    } 
  },
  methods: {
    Init () {
      let self = this
      self.boolLoading = true 
      self.GetGroups()
      self.LoadReportHistoryCategories(-1)
      this.Folders = [{ 'value': 1, 'text': 'Current Category' }, { 'value': 2, 'text': 'All Categories' }]
      this.SelectedFolder = this.Folders[0].value
      this.FAVORITES = 5
      this.UNASSIGNED = 4
      this.ARCHIVES = 6
      setTimeout(function () {
        self.initLoad = true
      }, 10000)

      self.interval = setInterval(() => self.LoadRunningReports(), 2000)

      setTimeout(function () {
        if (self.interval !== undefined) { clearInterval(self.interval) }
      }, 180000)
    },
    async GetGroups () {
      let self = this
      try {
        let response = await axios.get('/api/pvi/getgroups')
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            self.boolLoading = false
            self.initLoad = false
            self.groupids = response.data
            if (self.groupids.length > 0) {
              self.groupid = self.groupids[0]
            }
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }
        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    async LoadReportHistoryCategories (SelectedCategoryId) {
      let self = this

      try {
        let response = await axios.get('/api/mgauge/loadreporthistorycategories?templatetypeid=' + self.templatetypeid)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            
            self.ReportHistoryCategories = response.data
            self.boolLoading = false

            if (self.ReportHistoryCategories.length > 0) {
              // TODO: Add ===
              if (SelectedCategoryId !== -1) {
                var cats = self.ReportHistoryCategories.filter(x => x.CategoryId === SelectedCategoryId)
                if (cats.length > 0) { self.SelectedCategory = cats[0] }
              } else {
                self.SelectedCategory = self.ReportHistoryCategories[0]
              }
              // External search from excel mguage report
              if (localStorage.getItem('PendingReport') !== null && localStorage.getItem('PendingReport') !== undefined) {
                localStorage.setItem('PendingReport', '' + (parseInt(localStorage.getItem('PendingReport')) + 1))
              }
              if (localStorage.getItem('PendingReport') === 2) {
                this.externalReporting()
                localStorage.removeItem('PendingReport')
                localStorage.removeItem('externalReportHistory')
              } else {               
                self.SetActiveCategory(self.SelectedCategory)
              }
            }
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    async LoadReportHistory(category) { 
      let self = this
      try {
        let response = await axios.get('/api/mgauge/LoadReportHistory?templatetypeid=' + self.templatetypeid + '&groupId=' + self.groupid + '&categoryId=' + category.CategoryId)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            this.SelectedReports = this.filteredReports = response.data
            self.rhtotalRows = response.data.length
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    async LoadReportHistorySearch (searchValue) {
      let self = this
      try {
        let response = await axios.get('/api/mgauge/LoadReportHistory?templatetypeid=' + self.templatetypeid + '&groupId=' + self.groupid + '&searchValue=' + searchValue)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            this.SelectedReports = this.filteredReports = response.data
            self.rhtotalRows = response.data.length
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    externalReporting () {
      this.canFilter = true
      var params = JSON.parse(localStorage.getItem('externalReportHistory'))
      if (params !== null && params !== '' && params !== undefined) {
        this.SelectedFolder = this.Folders[1].value
        this.searchValue = params.report_id
        this.searchReport()
        if (this.externalReport) {
          localStorage.removeItem('externalReportHistory')
          this.externalReport = false
        }
        this.externalReport = true
      }
    },
    handleDropCustom (categoryTo, template, event) {
      if (typeof template !== 'undefined') {
        var reports = this.filteredReports.filter(x => x.history_id === template.history_id)
        if (reports.length === 0) {
          alert('Please do not drop the selection in the same category!')
        } else {
          this.MoveSelectedReportsToDifferentCategory(reports, this.SelectedCategory.CategoryId, categoryTo.CategoryId)
        }
      }
    },
    async retryGroup() {
       let self = this
      try {
        let response = await axios.get('/api/pvi/retryreports?groupId=' + self.groupid)
        if (response !== undefined && response.status !== undefined && parseInt(response.status) === 200) {
          if (response.data !== undefined) {
            alert(response.data.Message, "Reports Queued")
          }
        }
      } catch (error) {
        if (error.response.status === 403) {
          self.$router.push('/login')
        }

        self.boolLoading = false
        self.errMsg = 'There was an error getting data : ' + error
        self.showDismissibleAlert = true
      }
    },
    refreshHistory () {
      let self = this
      self.boolLoading = true
      self.SetActiveCategory(sqlf.SelectedCategory.CategoryId)
      if (self.interval === undefined) {
        self.interval = setInterval(() => self.LoadRunningReports(), 30000)
        setTimeout(function () {
          if (self.interval !== undefined) { clearInterval(self.interval) }
        }, 180000)
      }
    },
    AddCustomCategory () {
      let self = this
      let StaticCategories = 3
      if (!(self.NewCategory !== null && self.NewCategory.length > 0)) {
        this.errMsg = 'The Category Name is empty'
        this.showDismissibleAlert = true
        return
      }

      if (self.ReportHistoryCategories.filter(x => x.CategoryName === self.NewCategory).length === 0) {
        let result = confirm('This will save the changes you have made. Are you sure?', 'Confirmation')
        result.then((dialogResult) => {
          if (dialogResult) {
            const CustomCategory = {
              'CategoryId': -1,
              'CategoryTypeId': 2,
              'CategoryName': self.NewCategory
            }
            self.NewCategory = ''
            self.SaveTemplateCategoryChanges(CustomCategory)
          }
        })
      } else {
        this.errMsg = 'The Category Name is already in the list'
        this.showDismissibleAlert = true
      }
    },
    SaveTemplateCategoryChanges (CustomCategory) {
      axios.post('/api/mgauge/savemgaugecategory', CustomCategory)
        .then(response => {
          this.boolLoading = false
          this.initLoad = false
          this.LoadReportHistoryCategories(this.SelectedCategory.CategoryId)
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    DeleteCategory (CustomCategory) {
      axios.post('/api/mgauge/deletemgaugecategory', CustomCategory)
        .then(response => {
          if (response.data.error !== undefined) {
            this.errMsg = response.data.error
            this.showDismissibleAlert = true
          }
          this.LoadReportHistoryCategories(-1)
          this.boolLoading = false
          this.initLoad = false
        })
        .catch(error => {
          console.log('error', error)
          if (error.response.status === 403) { this.$router.push('/login') }

          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    selectAll () {
      if (this.IsAllSelection === true) {
        for (var i = 0; i < this.filteredReports.length; i++) {
          var element = this.filteredReports[i]
          element['IsSelected'] = true
        }
      } else {
        for (var i = 0; i < this.filteredReports.length; i++) {
          var element = this.filteredReports[i]
          element['IsSelected'] = false
        }
      }
    },
    archiveCategory (category) {
      let result = confirm('This action will archive all reports and the category [' + category.CategoryName + '] will be delete. Are you sure?', 'Confirmation')
      result.then((dialogResult) => {
        if (dialogResult) {
          var archiveCats = this.ReportHistoryCategories.filter(x => x.CategoryId === this.ARCHIVES)
          if (archiveCats.length > 0) {
            this.ArchiveGaugeCategoryAndDelete(category.CategoryId, archiveCats[0].CategoryId)
          }
        }
      })
    },
    moveReportToFavorites (report) {
      var confirm_message = confirm('Are you sure you want to make the following change? NOTE: The report will be moved to the Category Assign.')
      if (confirm_message === true) {
        var SelectedElements = []
        SelectedElements.push(report)
        this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.categoryId, this.FAVORITES, true, false)
      }
    },
    moveOneReportToCategory (report, CategoryId) {
      console.log('CategoryId', CategoryId)
      console.log('this.ReportHistoryCategories', this.ReportHistoryCategories)
      var cats = this.ReportHistoryCategories.filter(x => x.CategoryId === CategoryId)
      console.log('cats', cats)
      var categoryTo = null
      if (cats.length > 0) { categoryTo = cats[0] }

      let result = confirm("Your report(s) will not be deleted. Note: The report(s) will be moved to '" + categoryTo.CategoryName + "' Section")
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          SelectedElements.push(report)

          this.MoveSelectedReportsToDifferentCategory(SelectedElements, report.categoryId, categoryTo.CategoryId)
        }
      })
    },
    moveSelectionToCategory () {
      let result = confirm('Are you sure you want to make the following change? NOTE: The report(s) will be moved to the Category Assign.')
      result.then((dialogResult) => {
        if (dialogResult) {
          var SelectedElements = []
          this.SelectedReports.filter(x => this.IsSelected(x)).forEach(function (report) {
            SelectedElements.push(report)
          })
          // console.log("moveSelectionToCategory SelectedElements", SelectedElements);
          this.MoveSelectedReportsToDifferentCategory(SelectedElements, this.SelectedCategory.CategoryId, this.MoveCategory) // this.MoveCategory => model in view
        }
      })
    },

    IsSelected (report) {
      return (typeof report['IsSelected'] !== 'undefined' && report.IsSelected === true)
    },
    ArchiveGaugeCategoryAndDelete(CategoryIdFrom, CategoryIdTo) {      
      axios.post('/api/mgauge/LoadReportHistory?templatetypeid=' + self.templatetypeid + '&groupId=' + self.groupid + '&categoryId=' + CategoryIdFrom)
        .then(response => {
          var SelectedElements = response.data// ;.Reports;
          this.boolLoading = false
          this.changesSaved = true

          var CategoryTypeId = 2 // Category Type : check for PVI
          var IDS = SelectedElements.map(function (element, index, array) {
            return element.history_id
          })

          var TransferObject = {
            SelectedElements: IDS,
            CategoryIdFrom: CategoryIdFrom,
            CategoryIdTo: CategoryIdTo,
            CategoryTypeId: CategoryTypeId
          }
          axios.post('/api/mgauge/transfermgaugereporthistory', TransferObject)
            .then(response => {
              console.log('DONE!!')
              var cats = this.ReportHistoryCategories.filter(x => x.CategoryId === TransferObject.CategoryIdFrom)
              if (cats.length > 0) {
                this.DeleteCategory(cats[0])
              } else {
                this.errMsg = 'There was an error getting deleting the category : '
                this.showDismissibleAlert = true
              }

              this.boolLoading = false
              this.changesSaved = true
            })
            .catch(error => {
              console.log('ERROR!!')
              if (error.response.status === 403) {
                this.$router.push('/login')
              }
              this.boolLoading = false
              this.errMsg = 'There was an error getting data : ' + error
              this.showDismissibleAlert = true
            })
        })
        .catch(error => {
          // console.log("ERROR!!")
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    MoveSelectedReportsToDifferentCategory (SelectedElements, CategoryIdFrom, CategoryIdTo) {
      var CategoryTypeId = 2 // Category Type : check for PVI
      var IDS = SelectedElements.map(function (element, index, array) {
        return element.history_id
      })

      var TransferObject = {
        SelectedElements: IDS,
        CategoryIdFrom: CategoryIdFrom,
        CategoryIdTo: CategoryIdTo,
        CategoryTypeId: CategoryTypeId
      }
      axios.post('/api/mgauge/transfermgaugereporthistory', TransferObject)
        .then(response => {
          // console.log("DONE!!")
          this.LoadReportHistoryCategories(this.SelectedCategory.CategoryId)
          this.boolLoading = false
          this.changesSaved = true
        })
        .catch(error => {
          // console.log("ERROR!!")
          if (error.response.status === 403) {
            this.$router.push('/login')
          }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },
    IsNotSelectedReport (report, SelectedElements) {
      return (SelectedElements.filter(x => x.report_id === report.report_id).length === 0)
    },
    SetActiveCategory (category) {
      this.SelectedCategory = category

      this.TransferCategories = this.ReportHistoryCategories.filter(x => x.CategoryId !== this.SelectedCategory.CategoryId)
      this.LoadReportHistory(category)
    },
    IsCategorySelected (CategoryId) {
      return CategoryId === this.SelectedCategory.CategoryId
    },
    searchReport () {
      let self = this
      if (self.SelectedFolder === 1) {
        if (self.searchValue.length === 0) {
          self.SetActiveCategory(self.SelectedCategory)
        } else {
          self.filteredReports = self.SelectedReports.filter(x =>
            x.title.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1 ||
            x.report_id === ('' + self.searchValue) ||
            x.createdby.toUpperCase().indexOf(self.searchValue.toUpperCase()) !== -1
          )
        }
      } else {
        self.LoadReportHistorySearch(self.searchValue)
      }
    },

    DownloadReport (download) {
      this.boolLoading = true
      const options = {
        method: 'POST',
        data: download,
        responseType: 'blob',
        url: '/api/mgauge/downloadreport?templatetypeid='+this.templatetypeid
      }
      axios(options)
        .then(response => {
          this.boolLoading = false
          let fileName = response.headers['content-disposition'].split('filename=')[1]
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/zip' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', response.headers['content-disposition'].split('filename=')[1])
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          if (error.response.status === 403) { this.$router.push('/login') }
          this.boolLoading = false
          this.errMsg = 'There was an error getting data : ' + error
          this.showDismissibleAlert = true
        })
    },

    ChangedFolder() {
      if (this.SelectedFolder.value !== 1) {
        if (this.searchValue.length > 0) { this.LoadReportHistorySearch(this.searchValue) }
      } else {
        this.SetActiveCategory(this.SelectedCategory)
      }
    },

    LoadRunningReports () {
      axios.get('/api/mgauge/loadrunningreports?templatetypeid='+this.templatetypeid)
        .then(response => {
          this.runningReports = response.data.runningReports
          this.totalRows = this.runningReports.length
        })
        .catch(error => {
        })
    },
    CancelReport(data) {
      let result = confirm("Are you sure you want to cancel this report?")
      result.then((dialogResult) => {
        if (dialogResult) {
          axios.post('/api/mgauge/cancelReport', data)
            .then(response => {
              setTimeout(function () {
                this.refreshHistory()

              }, 1000);
              this.LoadReportHistoryCategories(this.SelectedCategory)
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }
            })
        }
      })
    },
    DeleteReport (report) {
      if (report === undefined) {
        if (confirm('This will clear all report history for this account. Are you sure?')) {
          const options = {
            method: 'POST',
            data: { 'item': { 'report_id': -1 } },
            responseType: 'blob',
            url: '/api/mgauge/deletereport'
          }
          axios(options)
            .then(response => {
              this.refreshHistory()
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }
            })
        }
      } else {
        if (confirm('Are you sure you want to delete this?')) {
          const options = {
            method: 'POST',
            data: report,
            responseType: 'blob',
            url: '/api/mgauge/deletereport'
          }
          axios(options)
            .then(response => {
              this.refreshHistory()
            })
            .catch(error => {
              if (error.response.status === 403) {
                this.$router.push('/login')
              }
            })
        }
      }
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  filters: {
    formatDate: function (str) {
      if (!str) { return '' }
      str = new Date(str)
      return moment(String(str)).format('MM/DD/YY hh:mm A')
    }, 
    To150MaxChars: function (str) {
      if (!str) { return '' }
      return str.substring(0, 150)
    }

  },
  beforeDestroy: function () {
    let self = this
    if (self.interval !== undefined) { clearInterval(self.interval) }
  },
  mounted () {
    // boolLoading must be set to false on data() binding so that mount hooks the change
    this.boolLoading = true
    this.initLoad = false
  }
}
</script>
<style>
  .table > tbody > tr > td {
    /*vertical-align: middle;*/
  }
  .table-xtra-condensed > thead > tr > th,
  .table-xtra-condensed > tbody > tr > th,
  .table-xtra-condensed > tfoot > tr > th,
  .table-xtra-condensed > thead > tr > td,
  .table-xtra-condensed > tbody > tr > td,
  .table-xtra-condensed > tfoot > tr > td {
    padding: 2px 0.3rem;
  }
  .table-xtra-condensed.table {
    margin-bottom: initial !important;
  }
  body {
    background-color: initial;
  }
  .progress-bar {
    min-width:15px;
  }
  .bordered {
    border:1px solid lightgray;
  }
  .reports {
    display: flex;
    flex:10;
    flex-flow: column;
    border: 1px solid lightgray;
    max-height: 500px;
    min-height: 300px;
    overflow-y:auto;
  }
  .report_row {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    transition: 0.3s;
  }

  .report_row_slim_header {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    background-color: lightgray;
    height: 35px;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    padding-top: 2px;
    transition: 0.3s;
  }

  .report_row_hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #f0f3f5;
    /*font-weight: bold;*/
  }

  .report_row:hover {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 50px;
    justify-content: center;
    align-items: center;
    padding-bottom: 5px;
    padding-top: 5px;
    background-color: #eae1e1;
    /*font-weight: bold;*/
  }

  .category {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    font-weight:100;
    transition: 0.3s;
  }
  .category:hover {
    background-color: #ddd;
    opacity: 0.6;
  }
  .category_selected {
    background-color: #ddd;
    font-weight: bold;
  }

  .headerCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    /*height: 40px;*/
    justify-content: center;
    align-items: center;
    background-color: #f0f3f5;
  }
  .customCategory {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    height: 40px;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
  }
  .customCategory:hover {
    background-color: #ddd;
    opacity: 0.6;
  }

  .categories {
    display: flex;
    flex: 1;
    flex-flow: column;
    width: 150px;
  }
  .category_action {
    display: flex;
    flex: 2;
    margin-right:10px;
  }
  .category_title {
    display: flex;
    flex: 10;
    margin-left: 10px;
  }
  .report_id {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left:10px;

  }
  .report_template_name {
    display: flex;
    flex-flow: column;
    flex: 5;
    padding-left: 3px;
  }
  .report_user {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_category {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_date {
    display: flex;
    flex-flow: column;
    flex: 2;
    padding-left: 3px;
  }
  .report_time {
    display: flex;
    flex-flow: column;
    flex: 1;
  }
  .report_xls {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_html {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_json {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_action {
    display: flex;
    flex-flow: column;
    flex: 1;
    padding-left: 3px;
  }
  .report_row_slim_header {
    display: flex;
    flex-flow: row;
    border-bottom: 1px solid lightgray;
    background-color:lightgray;
    height: 35px;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    padding-top: 2px;
    transition: 0.3s;
  }
</style>



// WEBPACK FOOTER //
// src/views/PVIReportHistory.vue